$(document).ready(function(){
  
  /** Start script for free mask check on product page **/
  if ($("body").hasClass("product-free-mask-checkbox")) {
    var chkFreeChk ="0";
    $(document).on('change','.freeMaskChk', function(){
      console.log('changed checkbox');
      if(this.checked) {
        console.log('checkbox is checked');
        chkFreeChk = '1';
      } else{
        console.log('checkbox is not checked');
        chkFreeChk = '0';
      }
    });
    $(document).on('click','#Prd_cust_act', function(){
      console.log("chkFreeChk: "+chkFreeChk);
      if(chkFreeChk == '1'){
        console.log('need to add free');
        var FreePrdID= 31814051496051;
        var CartItemsQty = [];
        $.getJSON('/cart.js', function(cart) {
          console.log(cart);
          if(cart.item_count > 0){
            console.log('cart have items');
            $.each(cart.items, function(index, cartItem) {
              CartItemsQty.push(cartItem.variant_id);
            });
            console.log(CartItemsQty);
            console.log("FreePrdID Item: "+FreePrdID);
            var ArrayFountItem= jQuery.inArray(parseInt(FreePrdID),CartItemsQty);
            if(ArrayFountItem > -1){
              console.log('free product id exist');
              $('.DefaultACT')[0].click();
            } else{
              console.log('product id not exist');
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: { quantity: 1, id: FreePrdID },
                dataType: 'json',
                async:false
              });
              $('.DefaultACT')[0].click();
            } // if product not existing in cart
          } else{ 
            console.log('no item in cart');
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: { quantity: 1, id: FreePrdID },
              dataType: 'json',
              async:false
            });
            $('.DefaultACT')[0].click();
          } // if cart don't have any item

        }); // check if product exist in cart or not
      } else{
        $('.DefaultACT')[0].click();
      }
    });
  }
  /** End script for free mask check on product page **/
  
  /** Start script for cart page free product check **/
  if ($("body").hasClass("cart")) {
    var CartTotal= $('.MainCartArea').attr('data-subtotal');
    var cartgiftTotal= CartTotal-5000;
    console.log("cartgiftTotal: "+cartgiftTotal+" CartTotal: "+CartTotal);
    console.log("CartTotal: "+CartTotal);
    var checklist = false;
    var checkgiftCard = false;
    $(".mainCartloopLeft").each(function(){
      var idGetDef = $(this).attr("data-id");
      console.log("idGetDef: "+idGetDef);
      if(idGetDef == "32865000782"){
        console.log('gift card product already in cart');
        checkgiftCard = true;
        return false;
      }
    });
    $(".mainCartloopLeft").each(function(){
      var idGetDef = $(this).attr("data-id");
      console.log("idGetDef: "+idGetDef);
      if(idGetDef == "31814051496051"){
        console.log('free mask product already in cart');
        checklist = true;
        return false;
      }
    });
    if((checklist==true) && (checkgiftCard==true) && (cartgiftTotal<4900)){
      console.log('cart total less then 49');
      console.log('removing free product');
      var cartUpdates = { 31814051496051 : 0 }
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json',
        success: function(data) { 
          window.location.href = '/cart';
        }
      });
    } 
    if((checklist==true) && (CartTotal<4900)){
      console.log('cart total less then 49');
      console.log('removing free product');
      var cartUpdates = { 31814051496051 : 0 }
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json',
        success: function(data) { 
          window.location.href = '/cart';
        }
      });
    }
  }
  /** End script for cart page free product check **/
  
  


  /**  captcha reqired on WILL YOUR INSURANCE PAY? ***/
  window.onload = function() {
    var $recaptcha = document.querySelector('#g-recaptcha-response');

    if($recaptcha) {
      $recaptcha.setAttribute("required", "required");
    }
    
  };

  $(".insurance-pay-salesforce-btn").click(function(){
   $('.cust_field').each(function() {
     if($(this).val() ==""){
       return false;
     }
      else{
       if (grecaptcha.getResponse() == ""){
          alert("Please fill captcha");
        } 
       // alert("Please fill captcha");
        //$(".Cust_error_msg").css("display","block");
        return false;
      }
   });    
  });
 /**  end captcha reqired on WILL YOUR INSURANCE PAY? ***/
  
}); // end document ready




